import { getAuthHeaders } from "../../utils/authHeader";

const serverUrl = process.env.REACT_APP_SERVER;

export const fetchSlackProfile = async (extUserId) => {
  if (!extUserId) throw new Error("Missing extUserId");
  const res = await fetch(`${serverUrl}/slack/profile?extUserId=${extUserId}`, {
    credentials: "include",
  });

  if (!res.ok) throw new Error("Failed to fetch Slack profile");
  return res.json();
};

export const fetchTrelloProfile = async (extUserId) => {
  if (!extUserId) throw new Error("Missing extUserId");

  const res = await fetch(
    `${serverUrl}/trello/profile?extUserId=${extUserId}`,
    { credentials: "include" },
  );

  if (!res.ok) throw new Error("Failed to fetch Trello profile");

  return res.json();
};

export const fetchOutlookProfile = async (extUserId) => {
  if (!extUserId) throw new Error("Missing extUserId");

  const res = await fetch(
    `${serverUrl}/microsoft/profile?extUserId=${extUserId}`,
    { credentials: "include" },
  );

  if (!res.ok) throw new Error("Failed to fetch Outlook profile");
  return res.json();
};

export const buildAuthUrl = (assistantId, state) =>
  `${serverUrl}/general-auth/auth/${assistantId}?state=${encodeURIComponent(
    state,
  )}`;

export const fetchProfile = async (state) => {
  const res = await fetch(
    `${serverUrl}/general-auth/profile?state=${encodeURIComponent(state)}`,
    { credentials: "include" },
  );

  if (!res.ok) throw new Error("Failed to fetch profile");
  return res.json();
};

export const fetchAsanaWorkspaces = async (settingUuid, assistantId) => {
  const res = await fetch(
    `${serverUrl}/asana/workspaces?settingUuid=${settingUuid}&assistantId=${assistantId}`,
    {
      credentials: "include",
      headers: {
        ...getAuthHeaders().headers,
      },
    },
  );

  if (!res.ok) throw new Error("Failed to fetch Asana workspaces");

  return res.json();
};

export const fetchAsanaProjects = async (settingUuid, workspaceId) => {
  const res = await fetch(
    `${serverUrl}/asana/projects?settingUuid=${settingUuid}&workspaceId=${workspaceId}`,
    {
      credentials: "include",
      headers: {
        ...getAuthHeaders().headers,
      },
    },
  );

  if (!res.ok) throw new Error("Failed to fetch Asana projects");

  return res.json();
};

export const fetchTrelloWorkspaces = async (settingUuid) => {
  const res = await fetch(
    `${serverUrl}/trello/workspaces?settingUuid=${settingUuid}`,
    {
      credentials: "include",
      headers: {
        ...getAuthHeaders().headers,
      },
    },
  );

  if (!res.ok) throw new Error("Failed to fetch Trello workspaces");

  return res.json();
};

export const fetchTrelloBoards = async (settingUuid, workspaceId) => {
  const res = await fetch(
    `${serverUrl}/trello/boards?settingUuid=${settingUuid}&workspaceId=${workspaceId}`,
    {
      credentials: "include",
      headers: {
        ...getAuthHeaders().headers,
      },
    },
  );

  if (!res.ok) throw new Error("Failed to fetch Trello boards");

  return res.json();
};

export const fetchTodoistWorkspaces = async (settingUuid) => {
  const res = await fetch(
    `${serverUrl}/todoist/workspaces?settingUuid=${settingUuid}`,
    {
      credentials: "include",
      headers: {
        ...getAuthHeaders().headers,
      },
    },
  );

  if (!res.ok) throw new Error("Failed to fetch Todoist workspaces");

  return res.json();
};

export const fetchTodoistProjects = async (settingUuid, workspaceId) => {
  const res = await fetch(
    `${serverUrl}/todoist/projects?settingUuid=${settingUuid}&workspaceId=${workspaceId}`,
    {
      credentials: "include",
      headers: {
        ...getAuthHeaders().headers,
      },
    },
  );

  if (!res.ok) throw new Error("Failed to fetch Todoist projects");

  return res.json();
};

export const fetchGithubOrganizations = async (settingUuid) => {
  const res = await fetch(
    `${serverUrl}/github/workspaces?settingUuid=${settingUuid}`,
    {
      credentials: "include",
      headers: {
        ...getAuthHeaders().headers,
      },
    },
  );

  if (!res.ok) throw new Error("Failed to fetch GitHub organizations");

  return res.json();
};

export const fetchGithubRepositories = async (settingUuid, workspaceId) => {
  let url = `${serverUrl}/github/projects?settingUuid=${settingUuid}`;

  if (workspaceId) {
    url += `&workspaceId=${workspaceId}`;
  }

  const res = await fetch(url, {
    credentials: "include",
    headers: {
      ...getAuthHeaders().headers,
    },
  });

  if (!res.ok) throw new Error("Failed to fetch GitHub repositories");

  return res.json();
};

export const fetchNotionDatabases = async (settingUuid) => {
  const res = await fetch(
    `${serverUrl}/notion/database?settingUuid=${settingUuid}`,
    {
      credentials: "include",
      headers: {
        ...getAuthHeaders().headers,
      },
    },
  );

  if (!res.ok) {
    throw new Error("Failed to fetch Notion databases");
  }

  return res.json();
};

export const fetchJiraWorkspaces = async (settingUuid) => {
  const res = await fetch(
    `${serverUrl}/jira/workspace?settingUuid=${settingUuid}`,
    {
      credentials: "include",
      headers: {
        ...getAuthHeaders().headers,
      },
    },
  );

  if (!res.ok) {
    throw new Error("Failed to fetch Jira workspaces");
  }

  return res.json();
};

export const fetchJiraProjects = async (settingUuid, workspaceId) => {
  const res = await fetch(
    `${serverUrl}/jira/projects?settingUuid=${settingUuid}&workspaceId=${workspaceId}`,
    {
      credentials: "include",
      headers: {
        ...getAuthHeaders().headers,
      },
    },
  );

  if (!res.ok) {
    throw new Error("Failed to fetch Jira projects");
  }

  return res.json();
};

export const fetchJiraBoards = async (settingUuid, workspaceId, projectKey) => {
  const res = await fetch(
    `${serverUrl}/jira/boards?settingUuid=${settingUuid}&workspaceId=${workspaceId}&projectKey=${projectKey}`,
    {
      credentials: "include",
      headers: {
        ...getAuthHeaders().headers,
      },
    },
  );

  if (!res.ok) {
    throw new Error("Failed to fetch Jira boards");
  }

  return res.json();
};


export const fetchLinearWorkspaces = async (settingUuid) => {
  const res = await fetch(
    `${serverUrl}/linear/workspaces?settingUuid=${settingUuid}`,
    {
      credentials: "include",
      headers: {
        ...getAuthHeaders().headers,
      },
    },
  );

  if (!res.ok) throw new Error("Failed to fetch Linear workspaces");

  return res.json();
};

export const fetchLinearProjects = async (settingUuid, workspaceId) => {
  const res = await fetch(
    `${serverUrl}/linear/projects?settingUuid=${settingUuid}&workspaceId=${workspaceId}`,
    {
      credentials: "include",
      headers: {
        ...getAuthHeaders().headers,
      },
    },
  );

  if (!res.ok) throw new Error("Failed to fetch Linear projects");

  return res.json();
};

export const fetchClickupWorkspaces = async (settingUuid) => {
  const res = await fetch(
    `${serverUrl}/clickup/workspaces?settingUuid=${settingUuid}`,
    {
      credentials: "include",
      headers: {
        ...getAuthHeaders().headers,
      },
    },
  );

  if (!res.ok) throw new Error("Failed to fetch Clickup workspaces");

  return res.json();
};

export const fetchClickupProjects = async (settingUuid, workspaceId) => {
  const res = await fetch(
    `${serverUrl}/clickup/spaces?settingUuid=${settingUuid}&workspaceId=${workspaceId}`,
    {
      credentials: "include",
      headers: {
        ...getAuthHeaders().headers,
      },
    },
  );

  if (!res.ok) throw new Error("Failed to fetch Clickup projects");

  return res.json();
};

export const fetchClickupLists = async (
  settingUuid,
  spaceId,
) => {
  const res = await fetch(
    `${serverUrl}/clickup/lists?settingUuid=${settingUuid}&spaceId=${spaceId}`,
    {
      credentials: "include",
      headers: {
        ...getAuthHeaders().headers,
      },
    },
  );

  if (!res.ok) {
    throw new Error("Failed to fetch Clickup lists");
  }

  return res.json();
};

export const fetchPipedriveOrganizations = async (settingUuid) => {
  const params = new URLSearchParams({
    settingUuid,
  });

  const res = await fetch(
    `${serverUrl}/pipedrive/organizations?${params.toString()}`,
    {
      credentials: "include",
      headers: {
        ...getAuthHeaders().headers,
      },
    },
  );

  if (!res.ok) {
    throw new Error("Failed to fetch Pipedrive organizations");
  }

  return res.json();
};